<template>
  <FlotoFixedView>
    <MRow class="h-100">
      <MCol :size="12" class="flex flex-col h-100">
        <MRow :gutter="0" class="px-4">
          <MCol :sm="4" :size="12">
            <FlotoPageHeader :title="$tc('reset_password')" use-divider />
          </MCol>
          <FlotoScrollView :sm="4" :size="12">
            <FlotoForm @submit="resetPassword">
              <MRow :gutter="0" class="px-4">
                <MCol :sm="4" :size="12">
                  <PasswordInput
                    v-model="data.password"
                    vid="password"
                    :validation-label="$t('password')"
                    rules="required"
                    :placeholder="$t('password')"
                  >
                    <template v-slot:prefix>
                      <MIcon name="unlock-alt" />
                    </template>
                  </PasswordInput>
                </MCol>
              </MRow>
              <MRow :gutter="0" class="px-4">
                <MCol :sm="4" :size="12">
                  <PasswordInput
                    v-model="data.confirmPassword"
                    :placeholder="$t('confirm_password')"
                    :validation-label="$t('confirm_password')"
                    rules="required|confirmed:password"
                  >
                    <template v-slot:prefix>
                      <MIcon name="unlock-alt" />
                    </template>
                  </PasswordInput>
                </MCol>
              </MRow>
              <template v-slot:submit>
                <MRow :gutter="0" class="px-4 text-right">
                  <MCol :sm="4" :size="12">
                    <MButton
                      class="mr-2"
                      type="submit"
                      :loading="inProgress"
                      outline
                    >
                      {{ $tc('submit') }}
                    </MButton>
                    <FlotoLink
                      as-button
                      outline
                      :to="$currentModule.getRoute('self-service')"
                    >
                      {{ $tc('cancel') }}
                    </FlotoLink>
                  </MCol>
                </MRow>
              </template>
            </FlotoForm>
          </FlotoScrollView>
        </MRow>
      </MCol>
    </MRow>
  </FlotoFixedView>
</template>

<script>
import { resetPasswordApi } from '../support-portal-api'
import PasswordInput from '@components/password-input'
export default {
  name: 'ResetPassword',
  components: { PasswordInput },
  data() {
    return {
      data: {
        password: '',
        confirm_password: '',
      },
      inProgress: false,
    }
  },
  methods: {
    resetPassword() {
      this.inProgress = true
      resetPasswordApi({
        email: this.$route.params.email,
        password: this.data.password,
      })
        .then(() => {
          this.$router.push(this.$modules.getModuleRoute('auth', 'login'))
        })
        .finally(() => (this.inProgress = false))
    },
  },
}
</script>
